import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import { mixin, bp } from '../globalStyles'
import Content from './Content'
import ShowMoreButton from './ShowMoreButton'

const Card = styled.div`
  ${mixin.card};
  background: white;

  .TextCard--Hidden {
    display: none;

    ${props => props.open && 'display: block'};
  }

  @media (${bp.desktop}) {
    margin: 2rem 0;
    border: none;
    box-shadow: none;
    border-radius: 0;
    font-size: 2rem;

    .TextCard--Hidden {
      display: block;
    }

    .ShowMoreButton {
      display: none;
    }
  }
`
export default class TextCard extends React.Component {
  static propTypes = {
    content: PropTypes.string,
    contentLength: PropTypes.number
  }

  static defaultProps = {
    contentLength: 420
  }

  state = {
    open:
      this.props.content &&
      this.props.content.length <= this.props.contentLength
  }

  handleOpen = e => {
    e.preventDefault()
    this.setState(prevState => ({
      open: !prevState.open
    }))
  }

  sliceContent = content => {
    const contentSplit = content.split('\n')
    let contentSlices = [contentSplit[0], '']
    contentSplit.slice(1).forEach(str => {
      const newContent = contentSlices[0] + '\n' + str
      if (newContent.length <= this.props.contentLength) {
        contentSlices[0] = newContent
      } else {
        contentSlices[1] += '\n\n' + str
      }
    })
    return contentSlices
  }

  render () {
    const { content } = this.props
    const { open } = this.state
    if (!content) return null

    const contentSlices = this.sliceContent(content)

    return (
      <Card open={open}>
        <Content
          source={contentSlices[0]}
          style={{
            maxHeight: open ? 'none' : '25rem'
          }}
        />
        <Content className='TextCard--Hidden' source={contentSlices[1]} />
        {contentSlices[1] && (
          <ShowMoreButton open={open} handleOpen={this.handleOpen} />
        )}
      </Card>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/TextCard.js